import { observer } from "mobx-react-lite";

import {
  MDSBadge,
  MDSBadgeVariant,
  MDSButton,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIcon,
  MDSIconKind,
  MDSPlanCard,
  MDSPlanCardBackground,
  MDSPlanCardBorder,
  MDSPlanCardSlot,
  MDSPlanId,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { getProFeatures } from "@/pages/settings/components/subscription-management/data";
import { ProactiveSubscriptionPlanCard } from "@/pages/settings/components/subscription-management/proactive";
import {
  CardsRow,
  PlanContainer,
  TitleAndBadgeContainer,
} from "@/pages/settings/components/subscription-management/subscription.styles";

interface Props {
  canManagePlan: boolean;
  currentPlanPriceText: string;
  currentPlanStatusText: string;
  currentPlanTitleBadgeLabel: string;
  isProactiveTrialEligible: boolean;
  proactivePriceText: string;
  isSubscribingToProactive: boolean;
  onManagePlan: () => void;
  onSubscribeToProactive: () => void;
}

export const ProPlanManagement: React.FC<Props> = observer(
  ({
    canManagePlan,
    currentPlanPriceText,
    currentPlanStatusText,
    currentPlanTitleBadgeLabel,
    isProactiveTrialEligible,
    proactivePriceText,
    isSubscribingToProactive,
    onManagePlan,
    onSubscribeToProactive,
  }) => (
    <>
      <TitleAndBadgeContainer>
        <MDSText variant={MDSTextVariant.HeaderL}>Pro Plan</MDSText>
        <MDSBadge label="Current plan" variant={MDSBadgeVariant.Default} />
      </TitleAndBadgeContainer>

      <PlanContainer>
        <MDSText>{currentPlanStatusText}</MDSText>

        <CardsRow $columns>
          <MDSPlanCard
            plan={MDSPlanId.Paid}
            features={getProFeatures()}
            border={MDSPlanCardBorder.Default}
            background={MDSPlanCardBackground.Default}
          >
            <MDSText
              variant={MDSTextVariant.HeaderL}
              weight={MDSTextWeight.SemiBold}
              slot={MDSPlanCardSlot.Title}
            >
              Pro
            </MDSText>
            <MDSBadge
              label={currentPlanTitleBadgeLabel}
              variant={MDSBadgeVariant.Default}
              slot={MDSPlanCardSlot.TitleBadge}
            />
            <div slot={MDSPlanCardSlot.Price}>{currentPlanPriceText}</div>
            {canManagePlan ? (
              <MDSButton
                variant={MDSButtonVariant.Default}
                onClick={onManagePlan}
                slot={MDSPlanCardSlot.Footer}
              >
                Manage Pro Plan
                <MDSIcon kind={MDSIconKind.ExternalLink} slot={MDSButtonSlotName.RightIcon} />
              </MDSButton>
            ) : null}
          </MDSPlanCard>

          <ProactiveSubscriptionPlanCard
            badgeLabel="Recommended"
            isTrialEligible={isProactiveTrialEligible}
            proactivePriceText={proactivePriceText}
            isLoading={isSubscribingToProactive}
            isDisabled={isSubscribingToProactive}
            onSubscribe={onSubscribeToProactive}
          />
        </CardsRow>
      </PlanContainer>
    </>
  )
);
